<template>
    <div>      
        <div style="min-height: 80vh">
            <slot/>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import AppFooter from "./footer/footer.vue";

export default {
  components: {
    "app-footer": AppFooter,
  },
};
</script>